export enum RASymbols {
  MINUS = '—',
}
